import { useAuthStore } from './auth-provider/AuthProvider';

export function isAuthenticated() {
  return useAuthStore.getState().authenticated;
}
